export default {
  methods: {
    calcSubtotal() {
      let subtotal = 0;
      setTimeout(() => {
        this.model.rows.forEach(item => {
          subtotal += item.total;
        });
        this.model.subtotal = subtotal;
        this.setQuotationTotal();
      }, 50);
    },
    setDeadLine(param) {
      if (param instanceof Date) {
        this.model.delivery_date = new Date(param);
        const duration = parseInt(this.model.duration_time || 0, 10);
        const deadLine = parseInt(param.getUTCDate(), 10) + duration;
        this.model.delivery_date.setDate(deadLine);
      }
    },
    setPortionValue() {
      this.model.parcel_value = this.model.total / this.model.parcel;
    },
    setQuotationDiscount() {
      let discount = this.model.total - this.model.subtotal;
      if (this.model.discount_type === 'pct') {
        discount = (discount * 100) / this.model.total;
      }
      this.model.discount = discount;
    },
    setQuotationTotal() {
      if (this.model.discount_type === 'pct' && this.model.discount > 100) {
        this.model.discount = 100;
      }
      this.model.discount = this.model.discount || 0;
      let total = this.model.subtotal - this.model.discount;
      if (this.model.discount_type === 'pct') {
        total = this.model.subtotal * ((100 - this.model.discount) / 100);
      }
      this.model.total = total;
      this.setPortionValue();
    },
    setTotal(item) {
      // eslint-disable-next-line
      item.total =  Number(item.value) * Number(item.quantity);
      this.calcSubtotal();
    },
    setUnitValor(item) {
      // eslint-disable-next-line
      item.value = item.total / item.quantity;
      this.calcSubtotal();
    },
  },
};
